import { render, staticRenderFns } from "./ClientsRankingCard.vue?vue&type=template&id=3c3975b8&scoped=true"
import script from "./ClientsRankingCard.vue?vue&type=script&lang=js"
export * from "./ClientsRankingCard.vue?vue&type=script&lang=js"
import style0 from "./ClientsRankingCard.vue?vue&type=style&index=0&id=3c3975b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3975b8",
  null
  
)

export default component.exports